import { get } from './api';
import { BrandCatalogueResponse } from './schemas/getCatalogue';

export const getCatalogue = async (brandCode: string): Promise<BrandCatalogueResponse[]> => {
  try {
    const data = await get<BrandCatalogueResponse[]>(`/catalogue?brandCode=${brandCode}`);
    return data;
  } catch (err) {
    console.error('Fetch error:', err);
    throw err;
  }
};
